import { Component } from 'react'
import { RouterProps, withRouter } from '../../../../../../insfrastructure/utils/with-router-component'
import { Stepper } from './components/stepper'
import { CompanyData } from './components/company-data'
import { AboutCompany } from './components/about-company';
import { CompanyUserData } from './components/company-user-data';
import { ResumeWithRouter } from './components/resume';
import { CompanyManagerSignUp } from './components/company-manager-signup';
import './styles.sass';

type StepsMap = {
  company_data: string;
  about_company: string;
  company_user_data: string;
  resume: string;
}

type CompanyLookup = { cnpj: string; name: string } | null;

interface CompanyFormState {
  flow: 'legacy' | 'manager';
  company_lookup: CompanyLookup;
  cnpj_lookup: { exists: boolean; companyName: string; checked: boolean };
  selected_step: number;
  filled_steps: number;
  steps: StepsMap;
  company_data: { ie_free: boolean; cnpj: string } & Record<string, any>;
  about_company: Record<string, any>;
  company_user_data: Record<string, any>;
}

type FormName = 'company_data' | 'about_company' | 'company_user_data';

class CompanyForm extends Component<RouterProps, CompanyFormState> {
  state: CompanyFormState = {
    flow: 'legacy',
    company_lookup: null,
    cnpj_lookup: { exists: false, companyName: '', checked: false },
    selected_step: 1,
    filled_steps: 0,
    steps: {
      company_data: 'Dados da Empresa',
      about_company: 'Sobre a Empresa',
      company_user_data: 'Dados do Responsável',
      resume: 'Confirmação',
    },
    company_data: {
      ie_free: false,
      cnpj: ''
    },
    about_company: {},
    company_user_data: {}
  }

  onFillStep = <K extends FormName>(filled_steps: number, form_name: K, form_data: CompanyFormState[K]) => {
    this.setState((prevState) => ({
      filled_steps: filled_steps > prevState.filled_steps ? filled_steps : prevState.filled_steps,
      selected_step: filled_steps + 1,
      [form_name]: form_data
    } as Pick<CompanyFormState, 'filled_steps' | 'selected_step' | K>));
    
    window.scrollTo(0, 0);
  }

  onChangeStep = (selected_step: number) => {
    this.setState({ selected_step });
    window.scrollTo(0, 0);
  }

  onBack = () => {
    if (this.state.selected_step > 1) {
      this.setState({ selected_step: this.state.selected_step - 1 });
      window.scrollTo(0, 0);
    }
  }

  render() {
    if (this.state.flow === 'manager') {
      return (
        <div className='company-sign-up-form'>
          <CompanyManagerSignUp
            navigate={this.props.navigate}
            cnpj={this.state.company_lookup?.cnpj || ''}
            companyName={this.state.company_lookup?.name || ''}
            onBack={() => this.setState({
              flow: 'legacy',
              company_data: {
                ...this.state.company_data,
                cnpj: this.state.company_lookup?.cnpj || this.state.company_data.cnpj
              }
            })}
          />
        </div>
      );
    }

    return (
      <div className='company-sign-up-form'>
        <h3>Dados da Empresa</h3>
        <Stepper
        steps={this.state.steps}
        selectedStep={this.state.selected_step}
        filledSteps={this.state.filled_steps}
        />
        { this.state.selected_step === 1 && 
        <CompanyData
        form_data={this.state.company_data}
        mode='cnpj_gate'
        initialCnpjLookup={this.state.cnpj_lookup}
        onCnpjLookupChange={cnpj_lookup => this.setState({ cnpj_lookup })}
        onCnpjGateResolved={(flow, company_lookup, form_data) => {
          const updatedCompanyData = (
            form_data
              ? { ...this.state.company_data, ...form_data }
              : {
                ...this.state.company_data,
                cnpj: company_lookup?.cnpj || this.state.company_data.cnpj
              }
          ) as CompanyFormState['company_data'];
          const shouldAdvanceToStep2 = flow === 'legacy' && !!form_data;
          this.setState(prevState => ({
            flow,
            company_lookup: company_lookup || null,
            company_data: updatedCompanyData,
            filled_steps: shouldAdvanceToStep2 ? Math.max(prevState.filled_steps, 1) : prevState.filled_steps,
            selected_step: shouldAdvanceToStep2 ? 2 : prevState.selected_step
          }));
        }}
        onSubmit={(company_data) =>
          this.onFillStep(1, 'company_data', company_data as CompanyFormState['company_data'])
        } /> }

        { this.state.selected_step === 2 && 
        <AboutCompany
        form_data={this.state.about_company}
        onSubmit={(about_company) => this.onFillStep(2, 'about_company', about_company)}
        onBack={this.onBack} /> }

        { this.state.selected_step === 3 && 
        <CompanyUserData
        form_data={this.state.company_user_data}
        onSubmit={(company_user_data) => this.onFillStep(3, 'company_user_data', company_user_data)}
        onBack={this.onBack} /> }

        { this.state.selected_step === 4 && 
        <ResumeWithRouter
        company_data={this.state.company_data}
        about_company={this.state.about_company}
        company_user_data={this.state.company_user_data}
        onBack={this.onBack} /> }
      </div>
    )
  }
}

export default withRouter(CompanyForm);